import React, { memo } from 'react'
import { Link } from 'gatsby'

export const Item = memo(({ title, category, selectCategory }) => (
  <li
    className="item"
    role="tab"
    aria-selected={category === title ? 'true' : 'false'}
  >
    {/* <div onClick={() => selectCategory(title)}>{title}</div> */}
    <Link to="/" onClick={() => selectCategory(title)}>
      <span className="item_inner">{title}</span>
    </Link>
  </li>
))
